export const PLUGINS_DESIGN = {
    page: {
        container: "flex h-full w-full animate-in fade-in slide-in-from-bottom-4 duration-500",
    },
    sidebar: {
        container: "w-[240px] flex-shrink-0 bg-white border-r border-gray-100 flex flex-col h-full overflow-y-auto",
        header: "px-5 pt-5 pb-3",
        title: "text-lg font-bold text-gray-900 tracking-tight",
        nav: "px-3 flex flex-col gap-0.5",
        item: "flex items-center gap-2.5 px-3 py-2 rounded-xl text-sm transition-all duration-200 cursor-pointer",
        itemActive: "bg-[#7C3AED]/10 text-[#7C3AED] font-medium",
        itemInactive: "text-gray-600 hover:bg-gray-50 hover:text-gray-900",
        itemIcon: "w-4 h-4 flex-shrink-0",
        itemCount: "ml-auto text-[11px] font-semibold text-gray-400",
        itemCountActive: "ml-auto text-[11px] font-semibold text-[#7C3AED]",
        separator: "my-3 mx-3 h-px bg-gray-100",
        sectionLabel: "px-3 mb-2 text-xs font-semibold uppercase tracking-wider text-gray-400",
    },
    content: {
        container: "flex-1 flex flex-col h-full overflow-y-auto bg-slate-50/50",
        header: {
            container: "sticky top-0 z-10 bg-white border-b border-gray-100 px-6 py-4 flex items-center justify-between gap-4",
            left: "flex items-center gap-3",
            iconBox: "w-10 h-10 rounded-xl flex items-center justify-center bg-violet-50",
            title: "text-xl font-bold text-gray-900",
            subtitle: "text-xs text-gray-500",
        },
        searchWrapper: "relative",
        searchInput: "w-[280px] pl-9 pr-4 h-9 bg-gray-50 border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 hover:border-[#7C3AED]/50 transition-all text-sm rounded-xl",
        searchIcon: "absolute left-3 top-1/2 -translate-y-1/2 text-gray-400",
        grid: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 p-6",
        loadingContainer: "flex flex-col items-center justify-center py-20",
    },
    card: {
        container: "group bg-white rounded-xl border border-gray-100 hover:shadow-lg hover:border-[#7C3AED]/20 transition-all duration-300 cursor-pointer overflow-hidden flex flex-col",
        header: "p-4 pb-3 flex items-start gap-3",
        iconBox: "w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 shadow-sm",
        info: "flex-1 min-w-0",
        name: "text-sm font-semibold text-gray-900 truncate",
        description: "text-xs text-gray-500 mt-1 line-clamp-2 leading-relaxed",
        footer: "px-4 pb-4 pt-1 mt-auto flex items-center justify-between",
        price: "text-xs font-medium text-gray-400",
        installButton: "text-xs font-medium text-[#7C3AED] opacity-0 group-hover:opacity-100 transition-opacity duration-200",
    },
    badge: {
        plus: "px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider rounded-full bg-violet-100 text-violet-700",
        essencial: "px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider rounded-full bg-blue-100 text-blue-700",
        mini: "px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider rounded-full bg-green-100 text-green-700",
    },
    emptyState: {
        container: "flex flex-col items-center justify-center py-20 text-center",
        iconBox: "w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mb-4",
        title: "text-lg font-bold text-gray-900 mb-2",
        subtitle: "text-sm text-gray-500 max-w-sm",
    },
    modal: {
        backdrop: "fixed inset-0 z-[9999] bg-black/40 backdrop-blur-[2px] animate-in fade-in duration-200",
        panel: "fixed inset-0 z-[9999] flex items-center justify-center p-4",
        container: "bg-white rounded-2xl shadow-2xl w-full max-w-3xl max-h-[90vh] flex flex-col animate-in fade-in zoom-in-95 duration-300 overflow-hidden",
        header: {
            container: "flex items-start gap-5 p-6 pb-4",
            iconBox: "w-20 h-20 rounded-2xl flex items-center justify-center flex-shrink-0 shadow-md",
            info: "flex-1 min-w-0",
            name: "text-2xl font-bold text-gray-900",
            badgeRow: "flex items-center gap-2 mt-2",
            developer: "text-sm text-gray-500 mt-1",
            close: "p-2 rounded-xl hover:bg-gray-100 text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0",
        },
        body: "flex-1 overflow-y-auto px-6 pb-6",
        section: {
            container: "mb-5",
            title: "text-xs font-semibold uppercase tracking-wider text-gray-400 mb-3",
            card: "bg-gray-50 rounded-xl p-4",
        },
        permissionsGrid: "grid grid-cols-1 md:grid-cols-2 gap-4",
        permissionGroup: "space-y-2",
        permissionGroupTitle: "text-sm font-semibold text-gray-700 flex items-center gap-2",
        permissionItem: "text-sm text-gray-600 flex items-center gap-2",
        description: "text-sm text-gray-700 leading-relaxed",
        featureItem: "text-sm text-gray-600 flex items-center gap-2",
        footer: {
            container: "border-t border-gray-100 bg-gray-50/80 px-6 py-4 flex items-center justify-between",
            left: "flex items-center gap-3",
            installBtn: "flex items-center gap-2 px-5 py-2.5 bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-sm font-medium rounded-xl transition-all shadow-sm shadow-[#7C3AED]/20 active:transform active:scale-95",
        },
    },
};
